<template>
  <div id="home">

    <!-- header -->
    <div id="header" class="clearfix">
      <button class="btn btn-sm btn-outline-primary float-right" @click="resetProject">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        清空工程
      </button>

      <button class="btn btn-sm btn-outline-primary float-right" @click="exportProject">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        导出工程
      </button>

      <div class="btn btn-sm btn-outline-primary float-right position-relative">
        <vue-file @change="importProject" type="Object" class="file position-absolute w-100 h-100"></vue-file>
        <i class="fa fa-folder-open-o" aria-hidden="true"></i>
        导入工程
      </div>

      <button class="btn btn-sm btn-outline-primary float-right" @click="exportConfig">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        导出应用配置
      </button>

      <!--
      <button class="btn btn-sm btn-outline-primary float-right" @click="exportChannelConfig">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        导出采集配置
      </button>
      -->

      <button class="btn btn-sm btn-outline-primary float-right" @click="applyConfig">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        保存应用配置
      </button>
    </div>

    <!-- body -->
    <div id="body">
      <nav class="nav nav-tabs" id="myTab" role="tablist">
        <a v-for="tabInfo of tabs" class="nav-item nav-link" :class="{active: tab === tabInfo.key}" href="javascript:;" @click="changeTab(tabInfo.key)">{{ tabInfo.name }}</a>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active">
          <component :is="tabComponent"></component>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import BasicTab from './home/tabs/basic'
  import DataCollectTab from './home/tabs/data-collect'
  import DataUploadTab from './home/tabs/data-upload'
  import UploadTab from './home/tabs/upload'
  import VueFile from '@/components/utils/vue-file'
  import db from '../extensions/db'
  import axios from 'axios'
  import config from '@/config'
  import {PostMessageType} from '../utils'

  export default {
    data () {
      return {
        tabComponent: '',
        tab: 'basic',
        tabs: [
          /*
          {
            key: 'basic',
            name: '基本信息',
            component: 'basic-tab'
          },
          */
          {
            key: 'data-collect',
            name: '数据采集',
            component: 'data-collect-tab'
          },
          {
            key: 'data-upload',
            name: '数据上报',
            component: 'data-upload-tab'
          }
          /*
          {
            key: 'connection',
            name: '数据上报(连接)',
            component: 'upload-tab'
          }
          */
        ]
      }
    },
    components: {
      BasicTab,
      DataCollectTab,
      DataUploadTab,
      UploadTab,
      VueFile
    },
    created () {
      /* default tab */
      this.changeTab('data-collect')

      /* load configs */
      ;[ 'plc', 'interface', 'type', 'func', 'du' ].forEach(name => {
        let obj = require(`@/config/${name}.json`)
        this.$store.commit('UPDATE_CONFIG', {
          type: name,
          data: obj
        })
      })
    },
    methods: {
      changeTab (key) {
        this.tab = key
        this.tabComponent = this.tabs.find(v => key === v.key).component
      },
      async importProject (name, data) {
        try {
          await db.load(data)
        } catch (err) {
          this.$notify({
            group: 'alert',
            type: 'error',
            title: '导入出错',
            text: err.message
          })
          return
        }

        this.$notify({
          group: 'alert',
          type: 'success',
          title: 'success',
          text: '导入成功'
        })
      },
      async exportProject () {
        try {
          const data = await db.dump()
          this.$download('store.db', JSON.stringify(data, null, 2))
        } catch (err) {
          this.$notify({
            group: 'alert',
            type: 'error',
            title: 'error',
            text: '导出失败'
          })
        }
      },
      async exportConfig () {
        try {
          let data = await db.generateConfig()
          let resp = await axios.post(config.network.configMetadata.url, data)

          resp.data.du = await db.genDataupload()

          this.$download('app-config.json', JSON.stringify(resp.data, null, 4))
        } catch (err) {
          if (typeof err.response === 'object') {
            alert(err.response.data)
          } else {
            alert(`Error: ${err.message}`)
          }
        }
      },
      async exportChannelConfig () {
        try {
          let data = await db.generateConfigWithoutMetadata()
          let resp = await axios.post(config.network.config.url, data)

          this.$download('app-config-collect.json', JSON.stringify(resp.data, null, 4))
        } catch (err) {
          if (typeof err.response === 'object') {
            alert(err.response.data)
          } else {
            alert(`Error: ${err.message}`)
          }
        }
      },
      async applyConfig () {
        try {
          /* app-config */
          let data = await db.generateConfig()
          let resp = await axios.post(config.network.configMetadata.url, data)

          resp.data.du = await db.genDataupload()

          /* project store */
          const store = await db.dump()

          /* message */
          const message = {
            appConfig: resp.data,
            store
          }

          window.parent.postMessage({
            type: PostMessageType.SaveData,
            data: message
          }, '*')
        } catch (err) {
          if (typeof err.response === 'object') {
            alert(err.response.data)
          } else {
            alert(`Error: ${err.message}`)
          }
        }
      },
      async resetProject () {
        db.reset()
      }
    }
  }
</script>

<style>
  #home {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  #nav-tabContent {
    border: 1px solid rgb(221, 221, 221);
    border-top: 0px;
    padding: 2rem 1rem;
  }

  #header {
    margin-bottom: 1rem;
  }

  #header > .btn {
    margin-right: 0.5rem;
    overflow: hidden;
  }

  #header .file {
    top: 0;
    left: 0;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue